module.exports = __webpack_public_path__ + "static/media/EgyptienneURWLig.c75c2076.ttf";